import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const shiftSchedulerDaysfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {

    const formFields = [
        {
            label: 'Employee',
            key: 'employee_id',
            type: 'select',
            placeholder: 'Select the employee',
            visible: true,
            width: '25%',
            options: response.employees || [],
        },
        {
            label: 'Date',
            key: 'date',
            type: 'date',
            placeholder: 'Enter the date',
            visible: true,
            width: '25%',
        },
        {
            label: 'Start Time',
            key: 'start_time',
            type: 'time',
            placeholder: 'Enter the start time',
            visible: true,
            width: '25%',
        },
        {
            label: 'End Time',
            key: 'end_time',
            type: 'time',
            placeholder: 'Enter the end time',
            visible: true,
            width: '25%',
        },
        {
            label: 'Break Times',
            key: 'break_times',
            type: 'table',
            placeholder: 'Enter the break times',
            visible: true,
            width: '25%',
            columns: []
        },
    ];

    const CustomFields = response.CustomFields;

    if (CustomFields && CustomFields.length > 0) {
        CustomFields.forEach((field) => {
            formFields.push({
                label: field.name,
                key: 'cf.' + field.key,
                type: field.type,
                placeholder: field.placeholder,
                visible: true,
                width: '25%',
                viewField: true,
            });
        });
    }

    return formFields;
}

export const shiftSchedulerDaysMobileCard = (item, index, getFieldValue) => {
    return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View>
            <Text>TEST</Text>
            <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
        </View>
    </Card>;
}

export const shiftSchedulerDaysMain = {
    fields: shiftSchedulerDaysfields,
    mobileCard: null
}


